import React, { Component } from 'react';
import { Drawer } from 'rsuite';

class ResultPanel extends Component {
    constructor(props) {
        super(props);
        this.state={
            show:false
        }
    }
    close=()=> {
        return this.props.show;
    }
    render() {
        return (
            <div>
                <Drawer
                    full
                    show={this.close()}
                    size={'lg'}
                >
                    <Drawer.Header>
                        <Drawer.Title>正演结果图</Drawer.Title>
                    </Drawer.Header>
                    <Drawer.Body>
                        <img
                            src={this.props.link}
                            alt="正在计算中"
                            title="右键另存为"
                             />
                    </Drawer.Body>
                    <Drawer.Footer>
                        {this.props.children}
                    </Drawer.Footer>
                </Drawer>
            </div>
        );
    }
}

export default ResultPanel;